module.exports = __webpack_public_path__ + "static/img/img-kjxzxqy-good-02.e10dd61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img-kjxzxqy-good-02.jpg
// module id = h3ex
// module chunks = 1